import React from "react";
import { useRouteMatch } from "react-router-dom";

import CardRegisterMultipleUsers from "components/Cards/CardRegisterMultipleUsers";

export default function RegisterMultipleUsers() {

  const selected_enterprise = useRouteMatch().params.id_enterprise;
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
          <CardRegisterMultipleUsers id_enterprise={selected_enterprise}/>
        </div>
      </div>
    </>
  );
}
